import { TotalOTStats } from '../../utils/video/opentok-connection';

export const SET_OPENTOK_STATS = 'SET_OPENTOK_STATS';
export function setOpenTokStats(openTokStats: TotalOTStats) {
	return {
		type: SET_OPENTOK_STATS,
		payload: openTokStats,
	};
}

export const SET_SHOW_DEBUG_UI = 'SET_SHOW_DEBUG_UI';
export function setShowDebugUI(showDebugUI: boolean) {
	return {
		type: SET_SHOW_DEBUG_UI,
		payload: showDebugUI,
	};
}

export const OPENTOK_STREAM_AUDIO_ADD_UNMUTED_ID = 'OPENTOK_STREAM_AUDIO_ADD_UNMUTED_ID';
export const OPENTOK_STREAM_AUDIO_REMOVE_UNMUTED_ID = 'OPENTOK_STREAM_AUDIO_REMOVE_UNMUTED_ID';
